import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import './common.css';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import chatlnpfp from './Userpfpc';
import usrf1 from './imgs/girlchair1.png';
import usrm1 from './imgs/boychair33.png';
import chair from './imgs/tallchairwb.png';
import {showprofile,reload} from './userdefaultdata';
import pusrf1 from './imgs/grlpfp.png';
import pusrm1 from './imgs/boypfp.png';
import {cleardv} from './clearmem';
import {Uprofile} from './Userprofile'; 
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';
export const Useraction=(villaid:any,uarr:any)=>{

const vtype =   parseInt(Usersession.getVillatype());
 const ispvt = vtype < 2?false:true;
//var userchats = [ {uid:30,pfpid:1,utf:true,uname:'mybotesdfd',x:'200px',y:'100px',age:20,point:10,items:5,frnds:3,pvilas:3},
var userchats = [ {uid:0,pfpid:1,utf:true,uname:'Rimjhim',x:'200px',y:'100px'	}];
if(uarr !='')userchats = uarr;
//alert(JSON.stringify(userchats));
let obj = {uid:30,pfpid:0,utf:true,uname:'mybotesdfd',x:'200px',y:'100px'};
let dx = '50px',dy = '50px';
//const [arr,setarr] = useState(userchats);

const loaduseraction=(e:any)=>{
  const userid = Usersession.getUserId();
  const px = (e.clientX) + 'px';
  const py = (e.clientY) + 'px';
  // addposition(px,py);
 // reload(userchats);

}
const addposition=(x:any,y:any)=>{
  const userid = Usersession.getUserId();
 

 //alert(e.clientX);
  for(let i =0;i< userchats.length;i++){
              
                 let rv = userchats[i];
	         const cv = rv['uid'];
 		 if(cv == userid){	
		  rv['x'] = x;
                  rv['y'] = y;
		  userchats[i] = rv;
                 

		 break;
		} 
		
	}
 
   // reload(userchats);
}

return(
     <div className="per100">
      <div className="per100"  id="villactions">
	 <div className="postinchat" id="uactiondv"  style={{height:'auto'}}>
	  <div className="chairdiv">
                       {
			userchats.map((row,index)=>(
                       <a href="#"  onClick={e=>showprofile(e,row)} className="blanka" title={row.uname} >
			  <div className="uchair">	
	  			{row.utf?(
                            <Girlspfp  itemid={row.pfpid} wth={'10vw'}  hgt={'20vh'}/>
          			):(
          		 <Boyspfp  itemid={row.pfpid} wth={'10vw'}  hgt={'20vh'}/>
				)}


			    </div>
			</a>
			))
                      }
	   
	 </div>	
        
	</div>
	
	</div>

     </div>
);

}
